/**
 * @generated SignedSource<<5881329293e61320b3b128693091b59f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedRespLinksBlock_viewer$data = {
  readonly isPopularSearchesEnabled: boolean | null;
  readonly " $fragmentType": "SharedRespLinksBlock_viewer";
};
export type SharedRespLinksBlock_viewer$key = {
  readonly " $data"?: SharedRespLinksBlock_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRespLinksBlock_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedRespLinksBlock_viewer",
  "selections": [
    {
      "alias": "isPopularSearchesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "popularSearches"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"popularSearches\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "833762a6a2e47222ba83b8fb2f8153f2";

export default node;
